export const works = [
	{
		id: "rift-ai",
		category: "Branding — Product",
		title: "Rift AI",
		description: "A node-based no code tool for non designers and developers",
		width: 442,
		height: 469,
	},
	{
		id: "casa-de-kairos",
		category: "Branding",
		title: "Casa De Kairos",
		description: "Selling watches and making watches at the same time",
		width: 442,
		height: 440,
	},
	{
		id: "lvi-media",
		category: "Branding — Website",
		title: "LVI Media",
		description: "A video production studio for language of champions.",
		width: 752,
		height: 502,
	},
	{
		id: "stella-daniels",
		category: "Branding — Website",
		title: "Stella Daniels",
		description: "A film producer & brand strategist",
		width: 328,
		height: 410,
	},
	{
		id: "denim-by-sarv",
		category: "Branding — Website",
		title: "Denim By Sarv",
		description: "Sarv denim archive—a collection shaped by movement and worn with intention.",
		width: 443,
		height: 572,
	},
];
